import { Box, Chip, Typography } from '@mui/material';
import { PrimaryMultiSelect, PrimaryTextField, SubTitle } from 'components';
import { IPlugin } from 'pages/dashboard/components/ent-account/components/edit-account/components/plugins/interface';
import { selectPluginData } from 'pages/dashboard/components/ent-account/components/edit-account/selector';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { IOption } from 'interfaces';
import { ICreateSessionForm } from '../../../../interface';

interface ISessionPluginsProps {
  plugins: IPlugin[];
}

interface IPluginConfigItemProps {
  plugin: IPlugin;
}

const PluginConfigItem: React.FC<IPluginConfigItemProps> = ({ plugin }) => {
  const { control } = useFormContext<ICreateSessionForm>();
  const pluginData = useSelector(selectPluginData);

  const inputItems = plugin?.pluginConfig?.filter((i) => i.type === 'input');
  const multiSelectItems = plugin?.pluginConfig?.filter((i) => i.type === 'multiSelect');

  const getMultiSelectOptions = React.useCallback((configKey: string): IOption[] => {
    const data = pluginData?.[plugin.key]?.[configKey];
    if (Array.isArray(data)) {
      return data.map((item: any) => ({
        id: item.id,
        value: item.id,
        text: item.name,
      }));
    }
    return [];
  }, [pluginData, plugin.key]);

  return (
    <div>
      <Typography sx={{ mb: 1 }}>{plugin.name}</Typography>
      {inputItems?.map((item) => (
        <div className="form-item" key={item.name}>
          <Controller
            control={control}
            // @ts-ignore
            name={`metaData.${plugin.key}.${item.key}`}
            render={({ field }) => <PrimaryTextField {...field} label={item.label} />}
          />
        </div>
      ))}
      {multiSelectItems?.map((item) => {
        const options = getMultiSelectOptions(item.key);
        return (
          <div className="form-item" key={item.name}>
            <Typography variant="body1">{item.name}</Typography>
            <Controller
              control={control}
              // @ts-ignore
              name={`metaData.${plugin.key}.${item.key}`}
              render={({ field }) => (
                <PrimaryMultiSelect
                  options={options}
                  value={Array.isArray(field.value) ? field.value : []}
                  onChange={(e: any) => {
                    field.onChange(e.target.value);
                  }}
                  renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {selected.map((value: any) => (
                        <Chip
                          key={value}
                          label={options.find((opt) => opt.value === value)?.text || value}
                          color="primary"
                        />
                      ))}
                    </Box>
                  )}
                />
              )}
            />
          </div>
        );
      })}
    </div>
  );
};

const SessionPlugins: React.FC<ISessionPluginsProps> = ({ plugins }) => (
  <div className="form-item">
    <SubTitle>Plugins</SubTitle>

    {plugins.map((plugin: IPlugin) => (
      <PluginConfigItem key={plugin.id} plugin={plugin} />
    ))}
  </div>
);

export default SessionPlugins;
